import { CalendarPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const pad = (n) => String(n).padStart(2, "0");
const stamp = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;

function endFor(start, endTime) {
  if (!endTime) return new Date(start.getTime() + 60 * 60 * 1000);
  const [h, m] = endTime.split(":").map(Number);
  const end = new Date(start);
  end.setHours(h, m, 0, 0);
  if (end <= start) end.setDate(end.getDate() + 1);
  return end;
}

function details(svc) {
  const lines = [`Tipo: ${svc.service_type || "-"}`];
  if (svc.required_volunteers) lines.push(`Volontari richiesti: ${svc.required_volunteers}`);
  if (svc.required_ambulances) {
    const amb = (svc.ambulances || []).map((a) => `${a.name}${a.plate ? ` (${a.plate})` : ""}`).join(", ");
    lines.push(`Ambulanze: ${svc.required_ambulances}${amb ? ` – ${amb}` : ""}`);
  }
  if (svc.required_vehicles?.length) lines.push(`Altri mezzi: ${svc.required_vehicles.map((v) => v.name).join(", ")}`);
  if (svc.required_medici) lines.push(`Medici richiesti: ${svc.required_medici}`);
  if (svc.required_infermieri) lines.push(`Infermieri richiesti: ${svc.required_infermieri}`);
  if (svc.notes) lines.push("", svc.notes);
  return lines.join("\n");
}

export function googleCalendarUrl(svc, d) {
  const start = new Date(d);
  const end = endFor(start, svc.end_times?.[d]);
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: `${svc.event_name}${svc.service_type ? ` · ${svc.service_type}` : ""}`,
    dates: `${stamp(start)}/${stamp(end)}`,
    ctz: "Europe/Rome",
    location: svc.location || "",
    details: details(svc),
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

const fmt = (d) => new Date(d).toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export function GoogleCalendarButton({ svc }) {
  const dates = svc.dates?.length ? svc.dates : [svc.date_time];
  const open = (d) => window.open(googleCalendarUrl(svc, d), "_blank", "noopener");
  const trigger = (
    <Button size="sm" variant="ghost" title="Aggiungi a Google Calendar" data-testid={`gcal-button-${svc.id}`} onClick={dates.length === 1 ? () => open(dates[0]) : undefined} className="hover:bg-muted">
      <CalendarPlus className="h-4 w-4" />
    </Button>
  );
  if (dates.length === 1) return trigger;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {dates.map((d, i) => (
          <DropdownMenuItem key={d} data-testid={`gcal-date-${svc.id}-${i}`} onSelect={() => open(d)}>
            {fmt(d)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
